import Model from '../models/model';
import util from '../util';

const { bIResultRenderer } = util;

const model = new Model({
	name: 'IncubatorCycleDetail',
	defaultSort: 'BIInTime DESC',
	disableAdd: true,
	disableDelete: true,
	readOnly: false,
	showGridRefreshBtn: true,
	columns: [
		{ header: 'TestControl', field: 'BIType', filterable: false, width: 150 },
		{ header: 'Load', field: 'LoadNumber', width: 200 },
		{ header: 'Sterilizer', field: 'Sterilizer', width: 150 },
		{ header: 'LotNumber', field: 'LotNumber', width: 200, },
		{ header: 'DateTime', field: 'BIInTime', width: 200, type: 'dateTime' },
		{ header: 'Incubator', field: 'IncubatorName', width: 200 },
		{ header: 'NumberOfWell', field: 'Well', width: 150, align: 'right', headerAlign: 'right' },
		{ header: 'Result', field: 'BIResultIcon', width: 150, filterable: false, renderCell: bIResultRenderer },
		{ header: 'Cycle', field: 'CycleCount', width: 150, align: 'right', headerAlign: 'right' }
	]
});

export const SterilizerPendingBiModel = model;
export default model.createFormBase();